import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Divider } from "@mui/material";
import { ListFormResultsRequest } from "protogen/documents_service_pb";
import { Document } from "protogen/documents_pb";
import { useListFormResults } from "services/documents";
import FlexPage from "components/layout/FlexPage";
import useIsMobile from "components/hooks/useIsMobile";
import FlexBox from "components/common/FlexBox";
import Breadcrumbs from "components/common/Breadcrumbs";
import DocumentsTable from "components/documents/DocumentsTable";

export default () => {
  const params = useParams();
  const isMobile = useIsMobile();
  const breadcrumbs = [
    { name: "Documents", link: "/documents" },
    { name: "Forms", back: true },
  ];

  const { request: listFormResultsRequest } = useListFormResults();
  const [results, setResults] = useState<Document[]>([]);
  const listDocuments = async () => {
    const r = await listFormResultsRequest(
      new ListFormResultsRequest({
        documentRef: params.documentRef,
      }),
    );
    setResults(r?.documents || []);
  };

  useEffect(() => {
    if (!params.documentRef) return;
    listDocuments();
  }, []);

  return (
    <FlexPage
      fullHeight
      headerPadding={false}
      sx={{
        maxWidth: "1000px",
        margin: isMobile ? "" : "auto",
        padding: isMobile ? "12px 20px" : "32px 48px",
        paddingBottom: "0px",
        gap: "20px",
        height: "100%",
      }}
    >
      <FlexBox
        stackedMobile
        justifyContent="space-between"
        alignItems={isMobile ? "start" : "center"}
        gap="12px"
        sx={{ flex: 0 }}
      >
        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </FlexBox>
      <Divider sx={{ marginBottom: "16px" }} />
      <DocumentsTable documents={results} layout="simple" />
    </FlexPage>
  );
};
